module.exports = __webpack_public_path__ + "img/icn_arrowback.104070f6.svg";